import { useState } from 'react';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { MenuItem, Select, Button, SelectChangeEvent } from '@mui/material'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import SearchBar from '../../components/SearchBar'

interface ReportsTopbarProps {
  showRedemptionType?: boolean;
}

function ReportsTopbar({ showRedemptionType = false }: ReportsTopbarProps) {

  const [searchTerm, setSearchTerm] = useState('');
  const [Range, setRange] = useState('default');
  const [redemptionType, setRedemptionType] = useState('default');

  const handleRangeChange = (event: SelectChangeEvent) => {
    setRange(event.target.value as string);
  };

  const handleRedemptionTypeChange = (event: SelectChangeEvent) => {
    setRedemptionType(event.target.value as string);
  };

  return (
    <div className="table_header">
      <div className="left_s">
        <SearchBar
          searchTerm={searchTerm}
          setDebouncedSearchTerm={setSearchTerm}
          placeholder="Search..."
        />
        <div className="form">
          {showRedemptionType && (
            <Select
              value={redemptionType}
              onChange={handleRedemptionTypeChange}
            >
              <MenuItem disabled value="default">Select Type</MenuItem>
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="promotion">Promotion</MenuItem>
              <MenuItem value="reward">Reward</MenuItem>
            </Select>
          )}
          <Select
            fullWidth
            value={Range}
            onChange={handleRangeChange}
          >
            <MenuItem disabled value="default">Select Date Range</MenuItem>
            <MenuItem value="1">Day</MenuItem>
            <MenuItem value="2">Week</MenuItem>
            <MenuItem value="3">Monthly</MenuItem>
            <MenuItem value="4">Yearly</MenuItem>
            <MenuItem value="5">Custom Range</MenuItem>
          </Select>
          {Range === "5" && (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="form_control"
                slots={{
                  openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="Pick date" />,
                }}
                slotProps={{
                  textField: {
                    placeholder: "Select Date",
                    fullWidth: true,
                    hiddenLabel: true,
                  },
                }}
                desktopModeMediaQuery="(min-width:0px)"
              />
            </LocalizationProvider>
          )}
        </div>
      </div>
      <div className="right_s">
        <Button className="btn btn_black"><FileDownloadIcon /> Export CSV</Button>
      </div>
    </div>
  )
}

export default ReportsTopbar